import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import Controls from 'containers/Manage-Admin/audit-log/controls';
import Row from 'containers/Manage-Admin/audit-log/Row';
import {
  Table,
  ResultsHeaderRow,
  ResultsHeader,
  TableData,
} from 'components/styled-components';
import { Section } from 'containers/Manage-Questionnaire/styled-components';
import { fetchAuditLog } from 'actions/utils';
import Loading from 'components/loading';
import Pagination from 'components/pagination';
import { NonIdealState } from '@blueprintjs/core';

const createShortcut = (label, dateRange) => ({ dateRange, label });
const cloneDate = date => new Date(date.getTime());

const createShortcutList = () => {
  const today = new Date();
  const makeDate = action => {
    const returnVal = cloneDate(today);
    action(returnVal);
    returnVal.setDate(returnVal.getDate() + 1);
    return returnVal;
  };

  const oneMonthAgo = makeDate(d => d.setMonth(d.getMonth() - 1));
  const twoMonthsAgo = makeDate(d => d.setMonth(d.getMonth() - 2));
  const threeMonthsAgo = makeDate(d => d.setMonth(d.getMonth() - 3));

  return [
    createShortcut('Past 30 Days', [oneMonthAgo, today]),
    createShortcut('Past 60 Days', [twoMonthsAgo, today]),
    createShortcut('Past 90 Days', [threeMonthsAgo, today]),
  ];
};

const AuditLogBase = ({ auditLog, isFetching, fetchAuditLog }) => {
  const shortcutList = createShortcutList();
  const [active, setActive] = useState(shortcutList[0]);
  const [perPage, setPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(0);

  const handlePageClick = currentPage => {
    setCurrentPage(currentPage);
  };

  const handlePerPageChange = perPage => {
    setPerPage(perPage.value);
    setCurrentPage(0);
  };

  /* call the api
   whenever the active changes */
  useEffect(() => {
    fetchAuditLog({ ...active, start: currentPage * perPage, limit: perPage });
  }, [active, currentPage, perPage]);
  const handleChangeDateRange = active => {
    setActive(active);
    setCurrentPage(0);
  };
  return (
    <>
      {isFetching && <Loading size={100} />}
      {!isFetching && (
        <>
          <Controls
            shortcutList={shortcutList}
            selectedValue={active}
            handleChangeDateRange={handleChangeDateRange}
          />
          <Section>
            <Table>
              <tbody>
                <ResultsHeaderRow whiteSpace="nowrap">
                  <ResultsHeader>Assessment ID</ResultsHeader>
                  <ResultsHeader>User ID</ResultsHeader>
                  <ResultsHeader>User Name</ResultsHeader>
                  <ResultsHeader>Date & Time</ResultsHeader>
                  <ResultsHeader>Action</ResultsHeader>
                  <ResultsHeader>Details</ResultsHeader>
                </ResultsHeaderRow>
                {auditLog.totalCount ? (
                  auditLog.logs.map(row => (
                    <Row data={row} key={row.auditLogID} />
                  ))
                ) : (
                  <TableData colSpan={6}>
                    <NonIdealState
                      icon="error"
                      title="No logs found"
                      description="There were no logs found within that time frame."
                    />
                  </TableData>
                )}
              </tbody>
            </Table>
          </Section>
        </>
      )}
      <Pagination
        perPage={perPage}
        currentPage={currentPage}
        numRecords={auditLog.totalCount}
        onPageClick={handlePageClick}
        handlePerPageChange={handlePerPageChange}
      />
    </>
  );
};

const mapStateToProps = state => ({
  auditLog: state.utils.auditLog,
  isFetching: state.utils.isFetchingAuditLog,
});

const AuditLog = connect(
  mapStateToProps,
  { fetchAuditLog }
)(AuditLogBase);

export default AuditLog;
